import React, { FC, useState } from 'react'
import { Control, FieldErrors, FieldPath } from 'react-hook-form'

import { Button, TextInput, Link, Loader, EmailInput, Checkbox } from 'UI'
import { LinkStyles, LinkTextStyles } from 'UI/Link/types'
import { ButtonSizes, ButtonStyles } from 'UI/Button/types'
import { StartRegistrationParams } from 'API/RegistrationService/types'

import cl from 'components/Auth/style.module.scss'

interface RegistrationFormStartProps {
	isLoading: boolean
	errors: FieldErrors<StartRegistrationParams>
	onSubmit: () => void
	goBack: () => void
	onChange: (
		name: FieldPath<Omit<StartRegistrationParams, 'schoolRole'>>
	) => (value: string) => void
	control: Control<StartRegistrationParams>
}

const RegistrationFormStart = ({
	isLoading,
	onSubmit,
	goBack,
	errors,
	onChange,
	control
}: RegistrationFormStartProps) => {
	const [isChecked, setIsChecked] = useState(false)

	return (
		<form noValidate onSubmit={onSubmit} className={cl.authForm}>
			<div className={cl.inputsContainer}>
				<TextInput
					error={errors.firstName?.message}
					placeholder="Имя"
					onChange={onChange('firstName')}
					control={control}
					name="firstName"
				/>
				<TextInput
					error={errors.lastName?.message}
					placeholder="Фамилия"
					onChange={onChange('lastName')}
					control={control}
					name="lastName"
				/>
				<EmailInput
					error={errors.email?.message}
					onChange={onChange('email')}
					control={control}
					name="email"
				/>
			</div>

			<div className={cl.linksContainer}>
				<div className={cl.privacyInfo}>
					<Checkbox
						name="privacyPolicy"
						control={control}
						onChange={() => setIsChecked(!isChecked)}
						// @ts-ignore
						labelTitle={
							<>
								Я согласен с{' '}
								<Link
									styleTypes={[LinkTextStyles.UNDERLINE, LinkStyles.PRIMARY]}
									href="/policy"
								>
									политикой конфиденциальности
								</Link>
							</>
						}
					/>
				</div>
			</div>

			<div className={cl.buttonsContainerRegistration}>
				<Button
					type="submit"
					disabled={isLoading || !isChecked}
					styleTypes={[
						ButtonSizes.WIDE,
						ButtonStyles.PRIMARY,
						ButtonStyles.ROUND
					]}
				>
					{isLoading ? <Loader /> : 'Дальше'}
				</Button>
				<Button
					onClick={goBack}
					className={cl.backBtn}
					styleTypes={[ButtonSizes.WIDE]}
				>
					Вернуться назад
				</Button>
			</div>
		</form>
	)
}

export default RegistrationFormStart
